import type { MaintenanceNotice } from './maintenance.models';

/** Active maintenance downtime (not the advance visibility window). */
export function isMaintenanceWindowActive(notice: MaintenanceNotice, now: Date): boolean {
  const startAt = new Date(notice.startAt);
  const endAt = new Date(notice.endAt);
  if (Number.isNaN(startAt.getTime()) || Number.isNaN(endAt.getTime())) {
    return false;
  }

  const timestamp = now.getTime();
  return timestamp >= startAt.getTime() && timestamp < endAt.getTime();
}

export function isValidMaintenanceNotice(notice: MaintenanceNotice): boolean {
  const startAt = new Date(notice.startAt);
  const endAt = new Date(notice.endAt);
  return (
    !Number.isNaN(startAt.getTime()) &&
    !Number.isNaN(endAt.getTime()) &&
    endAt.getTime() > startAt.getTime()
  );
}
